export const zh_CN = {
  shared_components: {
    common: {
      back: "返回",
      confirm_cancel: "确定取消？",
      current_executor: "当前执行者：",
      filter: "筛选条件",
      inspector: "检查人",
      load_more: "上拉加载更多...",
      no: "否",
      organization_structure: "组织架构",
      please_enter: "请输入",
      please_select: "请选择",
      reject: "驳回",
      required_mark: " *",
      responsible_person: "负责人",
      status: "状态",
      submit_date_end: "提交时间（止）",
      submit_date_start: "提交时间（起）",
      yes: "是",
      cancel: "取消",
      confirm: "确认",
      no_data: "暂无数据",
      delete: "删除",
      save: "保存",
      submit: "提交",
      map_point: "平面图标记",
      view_floor_plan: "查看平面图",
      can_multi_select: "可多选",
      choose_take_photo_msg: "拍照",
      project_cost_center_code: "负责单位",
      project_name: "组织架构",
      choose: "选择",
      get_data_failed: "获取数据失败！",
      go_back_key_img: "返回",
      please_select_last_finding_category: "请选择最低层级的隐患/发现分类。",
      floor_plan: "平面图"
    },
    add_inspection_object: {
      inspection_obj_add: "添加检查对象",
      inspection_obj_input: "请输入检查对象",
      inspect_object_key: "检查对象",
      add_must: "请至少添加一个检查对象",
      other: "其他"
    },
    corp_select: {
      please_select_last_location_for_inspection: "请选择最低层级的检查地点"
    },
    filter_modals: {
      capa_code: "CAPA编号",
      capa_exec_date: "审核/接收日期",
      capa_final_verifier: "CAPA关闭最终验证人",
      capa_finding_desc: "发现项描述",
      capa_finding_evidence: "发现项证据",
      capa_finding_no: "发现项编号",
      capa_main_process: "所属主过程",
      capa_person_in_charge: "整改负责人",
      capa_source: "CAPA来源",
      capa_subject_title: "CAPA主题",
      capa_sub_process: "所属子过程",
      completion_date: "完工日期",
      corrective_finished: "是否完成改善",
      data_scope: "数据范围",
      ehsq_number: "评估ID",
      end_time: "截止日期",
      end_time_not_lg_start_time: "结束时间不能小于开始时间",
      evaluation_method: "评估方式",
      following_field: "以下栏位资料会在任务表单保存后才产生",
      from: "(起)",
      full_name: "姓名",
      hazard_type: "灾害类型",
      help_center_doc_name: "文档名称",
      immediate_check_category: "检查分类",
      incident_informant: "通报人",
      inspection_level: "检查层级",
      job_name: "工作名称",
      locations: "地点",
      poba: "受伤部位",
      project_id: "项目ID",
      project_name: "项目名称",
      rate: "评级",
      reporting_department: "上报部门",
      responsibility_zone: "责任区域",
      audit_reviewer: "审核人",
      start_time: "开始日期",
      start_time_not_lg_end_time: "开始时间不能大于结束时间",
      supplier_id: "承包商ID",
      target_finished: "是否完成目标",
      task_code: "任务编号",
      to: "(止)",
      unsafe_behavior: "不安全行为",
      unsafe_condition: "不安全状况",
      violation_item: "违反事项",
      work_id_id: "作业ID",
      work_name: "作业名称",
      work_related: "工作相关",
      id_number: "身份证号",
      incident_involved_person: "事故当事人",
      incident_notifier_pro: "项目经理",
      incident_reporting: "事故上报",
      inspection_finding_category: "发现分类",
      inspection_form: "检查表",
      no: "否",
      project_cost_center: "组织架构",
      project_name_bbs: "厂房",
      reviewer: "评审人",
      service_type: "服务类型",
      submit_person: "上报人",
      verification_person: "验证人",
      yes: "是",
      audit_type_display_key: "检查类型",
      business_line: "业务线",
      cancel_button_key: "取消",
      check_table_table: "表格",
      contractor_company: "承包商公司",
      contractor_personnel_id: "承包商人员ID",
      corrective_action_title_key: "整改措施",
      due_date_end: "截止日期（止）",
      due_date_start: "截止日期（起）",
      end_date: "结束时间",
      incident_category: "事故类别",
      incident_location: "事故地点",
      incident_location_range: "地点范围",
      incident_organization: "权责单位",
      inspection_date_end: "检查时间（止）",
      inspection_date_start: "检查时间（起）",
      observer: "观察员",
      occupation: "职业/工种",
      org_operation: "大区",
      report_date_key: "上报日期",
      report_time: "上报时间",
      reset: "重置条件",
      schedule_name: "计划名称",
      area: "区域",
      project: "项目",
      years: "年份",
      report_start_time: "开始日期",
      report_end_time: "截止日期",
      audit_type: "审核类型",
      search_view_task_no_key: "任务编号:",
      select_upper_org_structure: "必须先选择上一级组织架构",
      start_date: "开始时间",
      task_type: "检查类型",
      work_area: "被观察区域",
      work_risk_level: "工作风险等级",
      working_area: "工作区域",
      select_current_executor: "选择当前执行者",
      select_final_verifier: "选择最终验证人",
      select_person_in_charge: "选择整改负责人",
      select_reporter: "选择上报人",
      select_reviewer: "选择审核人",
      select_verifier: "选择验证人",
      incident_schedule: "进度",
      task_name: "任务名称",
      incident_subject: "事故主旨",
      accident_number: "事故编号",
      select_capa_source: "选择CAPA来源",
      search_capa_source: "搜索CAPA来源",
      select_factory: "选择厂房",
      search_factory: "搜索厂房",
      search_employee: "搜索员工"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "暂未选择区域",
      please_mark_one_point_on_floor_plan: "请在平面图上标记一个点位",
      reset_zoom: "重置缩放",
      selected_areas: "已选择的区域"
    },
    image_annotator_modal: {
      arrow: "↗ 箭头",
      cancel: "取消",
      circle: "○ 圆",
      clear: "✕ 清空",
      pen: "✏ 笔",
      pinch_zoom: "🤏 双指缩放",
      rect: "□ 框",
      save: "保存标注",
      text_tool: "T 文字",
      title_arrow: "箭头",
      title_circle: "圆形",
      title_pen: "画笔",
      title_rect: "矩形",
      title_reset_zoom: "重置缩放",
      title_text: "文字",
      undo: "↩ 撤销"
    },
    my_title: {
      homepage: "首页",
      enterprise_wechat_exit_home_alert: "企业微信退出首页"
    },
    no_source_img: {
      no_data: "暂无资料"
    },
    org_select_modal: {
      choose_organization_structure: "选择组织架构"
    },
    popover_dialog: {
      save_local: "暂存在手机"
    },
    return_dialog: {
      close_case: "关闭",
      invalid: "无效"
    },
    select_picture: {
      choose_from_media_msg: "从相册选择",
      confirm_delete_msg: "确认删除？",
      get_image_fail: "获取图片失败"
    },
    select_picture_new: {
      attachement_download_fail: "附件下载失败",
      be_uploading: "正在上传",
      cancel_key: "取消",
      load_from_gallery: "从图库中加载",
      select_image_source: "选择图片来源",
      use_camera: "使用相机",
      use_file: "从文件中加载",
      camera_access_denied: "相机权限被拒绝，请在系统设置中开启",
      camera_not_found: "未发现设备上的摄像头。"
    },
    spinner: {
      data_load_msg: "数据加载中，请稍候..."
    },
    svg: {
      top: "顶部"
    },
    turn_to_send: {
      mission_assign_success: "转派成功",
      report_member: "调查组组员",
      select_mission_assignee_msg: "请选择任务转派人！",
      turn_to_send: "转派",
      turn_to_send_to: "任务转派给",
      project_cost_center_code: "项目成本中心代码"
    },
    select_file: {
      unsupported_format_desktop_only: "该附件格式暂不支持，请至电脑端查看",
      format_not_supported: "此文件格式暂不支持在线查看，请使用网页端界面进行下载查看。"
    },
    fabric_canvas: {
      please_select_first: "无选中物体，请先选中物体后再操作。",
      delete_current_instance_only: "移除失败，您只能移除对应此地点的绘制内容。"
    }
  }
};
